// extracted by mini-css-extract-plugin
module.exports = {"fragmentPage":"FragmentPage_fragmentPage__BjsQ5","components":"FragmentPage_components__9aLgE"};